import {
    OrdersListElementSubjectListElementType,
    OrdersListElementType,
    OrdersListIdProgressType,
    OrdersListMapType,
    OrdersSearchParamType,
    OrdersUpdateProgressType
} from "../interface";
import moment from "moment";

export const ordersSearchParamInit: OrdersSearchParamType = {
    fromDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    limit: 10,
    pageNo: 1,
    progress: "100000001",
    toDate: moment().format("YYYY-MM-DD"),
    //내부수정: 키워드 초기화
    keyword1: "",
    keywordType1: "1",
    keyword2: "",
    keywordType2: "1",
}

export const ordersListMapInit: OrdersListMapType = {
    list: [],
    totalCount: 0
}

export const ordersListElementInit: OrdersListElementType = {
    newShipmentId: "",
    newDtOrder: "",
    owneridValue: "",
    owningUserName: "",
    enduserName: "",
    customerName: "",
    newLCustomerValue: "",
    newLEnduserValue: "",
    newPProgress: 0,
    progressName: "",
    orderSubjectResList: [],
    currencyName: "",
    endDt: "",
    newDtShipment: "",
    newTxtProjectCode: "",
    newDAmount: 0,
    orderTypeName: "",
    recipientName: "",
    postCode: "",
    recipientMobilephone: "",
    shipmentAddress: "",
    shipmentNo: "",
    newPShipmentName: "",
    // 내부수정: 외화
    newPCurrency: 0,
    newDAmountForeign: 0,
}

export const ordersListElementSubjectListElementInit: OrdersListElementSubjectListElementType = {
    newLShipmentValue: "",
    newShipmentSubjectId: "",
    newPCurrency: "",
    newDUnitPrice: 0,
    newDExchangeRate: 0,
    newDWon: 0,
    newDTotal: 0,
    newLErpProductValue: "",
    newTxtStandard: "",
    newIQty: 0,
    newTxtNmItem: "",
    currencyName: "",
}

export const ordersListIdProgressInit: OrdersListIdProgressType = {
    newShipmentId: "",
    newPProgress: 0
}

export const ordersUpdateProgressInit: OrdersUpdateProgressType = {
    newShipmentId: "",
    progress: 0
}